
const modules = import.meta.glob('./*/*.ts', { eager: true });

const messages: Record<string, { translation: Record<string, any> }> = {};

Object.keys(modules).forEach((path) => {
  const match = path.match(/\.\/([^/]+)\/([^/]+)\.ts$/);
  if (match) {
    const [, lang, namespace] = match;
    const module = modules[path] as any;
    
    if (!messages[lang]) {
      messages[lang] = { translation: {} };
    }
    
    // Obtener todas las exportaciones del módulo
    const moduleExports = Object.keys(module).filter(key => key !== 'default');
    moduleExports.forEach(exportName => {
      messages[lang].translation[exportName] = module[exportName];
    });
  }
});

export default messages;
